import React, { useEffect } from 'react';
import styled from 'styled-components';
import { updateModal } from '@/store/modules/modal';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { useQueryClient } from 'react-query';
import uploadSuccessImage from '@/assets/refund/check_circle.png';

function PaymentCompleteModal() {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();

  const handleClose = () => {
    dispatch(updateModal({ isActive: false, data: null, type: null }));
  };

  useEffect(() => {
    queryClient.invalidateQueries('paymentDetail');

    const timer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <Wrapper>
      <Container>
        <CheckIcon src={uploadSuccessImage} alt='체크 아이콘' />
        <Title>결제 완료</Title>
        <Desc>결제가 완료되었습니다.</Desc>
        <Button
          onClick={() => {
            handleClose();
          }}
          active={true}
          disabled={false}
        >
          확인
        </Button>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 600;
  background-color: rgba(33, 33, 33, 0.1);
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  padding: 52px 32px 32px;
  position: relative;
  border-radius: 8px;
  background-color: ${(props) => props.theme.pointColors.white};
  filter: ${(props) => props.theme.boxShadow};
`;

const CheckIcon = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  margin-bottom: 8px;
  color: var(--Mono-80, #3a3b3e);
  text-align: center;

  /* WebHead/28_BD */
  font-family: Pretendard;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 42px */
  letter-spacing: -0.56px;
`;

const Desc = styled.p`
  color: var(--Mono-65, #5f6165);
  text-align: center;

  /* WebBody/16_MD */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;
const Button = styled.button<{ colored?: boolean; active: boolean }>`
  margin-top: 24px;
  width: 100%;
  height: 52px;
  flex: 1;
  background-color: ${(props) =>
    props.active ? (props.colored ? '#246cf6' : '#E5E6E8') : '#D3E2FD'};
  color: ${(props) =>
    props.active ? (props.colored ? '#fff' : '#3A3B3E') : '#fff'};
  border: 1px solid #246cf6;
  border: 1px solid ${(props) => (props.active ? '#E5E6E8' : '#D3E2FD')};
  border-radius: 8px;
  font-size: 16px;
  line-height: 150%;
  padding: 14px 20px;
  :hover {
    opacity: 0.85;
  }
`;

export default PaymentCompleteModal;
